<youtube-player 
    #player
    [videoId]="url | getEmbedYoutube"
    (ready)="onReady($event)"
    (stateChange)="onStateChange($event)">
</youtube-player>